import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
   
    inline: {
      display: 'inline',
    },
    userSuggestionUserName:{
      marginTop : "auto",
      marginBottom : "auto"
    }
  }));

export default useStyles;